import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children }) => {
    const userId = useSelector((state) => state.userDetailReducer.userId);
    if ([null, undefined, ""].includes(userId)) {
        return <Navigate to="/login" replace />;
    }
    return children;
};